import { atom } from "recoil";

export const noUseWorkspaceState = atom({
  key: 'noUseWorkspaceState',
  default: false
});
